import CreatingAcLoader from "../Loader/CreatingAcLoader";

export default function Footer({ currentStep, onBack, onNext, isLast, loading, disabledNext, bankVerified }) {
  return (
    <div className="mt-8 flex flex-col-reverse md:flex-row md:items-center md:justify-between gap-3">
      <button
        type="button"
        onClick={onBack}
        disabled={currentStep === 1}
        className="inline-flex items-center justify-center rounded-lg border border-slate-200 px-4 py-2.5 text-sm font-medium text-slate-700 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-slate-50"
      >
        Back
      </button> 

      <button
        type="button"
        onClick={onNext}
        disabled={loading || disabledNext }
        className={`inline-flex items-center justify-center rounded-lg px-5 py-2.5 text-sm font-semibold text-white shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500
          ${
            loading || disabledNext 
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-blue-600 hover:bg-blue-700"
          }
        `}
      >
        {loading ? (
          "Saving Details..."
        ) : isLast ? (
          "Sign & Finish"
        ) : (
          "Save & Continue"
        )}
      </button>

    </div>
  );
}



// import CreatingAcLoader from "../Loader/CreatingAcLoader";

// export default function Footer({ currentStep, onBack, onNext, isLast, loading }) {
//   return (
//     <div className="mt-8 flex flex-col-reverse md:flex-row md:items-center md:justify-between gap-3">
//       <button
//         type="button"
//         onClick={onBack}
//         disabled={currentStep === 1}
//         className="inline-flex items-center justify-center rounded-lg border border-slate-200 px-4 py-2.5 text-sm font-medium text-slate-700 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-slate-50"
//       >
//         Back
//       </button>
//       <button
//         type="button"
//         onClick={onNext}
//         disabled={loading}
//         className={`inline-flex items-center justify-center rounded-lg bg-blue-600 px-5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 ${
//           loading ? "opacity-60 cursor-not-allowed" : ""
//         }`}
//       >
//         {loading ? (
//           "Saving Details..."
//         ) : isLast ? (
//           "Sign & Finish"
//         ) : (
//           "Save & Continue"
//         )}
//       </button>

//     </div>
//   );
// }

// export default function Footer({ currentStep, onBack, onNext, isLast }) {
//   return (
//     <div className="mt-8 flex flex-col-reverse md:flex-row md:items-center md:justify-between gap-3">
//       <button
//         type="button"
//         onClick={onBack}
//         disabled={currentStep === 1}
//         className="inline-flex items-center justify-center rounded-lg border border-slate-200 px-4 py-2.5 text-sm font-medium text-slate-700 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-slate-50"
//       >
//         Back
//       </button>
//       <button
//         type="button"
//         onClick={onNext}
//         className="inline-flex items-center justify-center rounded-lg bg-blue-600 px-5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
//       >
//         {isLast ? "Sign & Finish" : "Save & Continue"}
//       </button>
//     </div>
//   );
// }